<section class="uk-section uk-position-relative" uk-height-viewport="" style="min-height: calc(100vh);">
  <div class="uk-container  uk-flex uk-flex-center">
    <div class="uk-text-center uk-width-3-4@s uk-border-rounded uk-overflow-hidden" [style]="containerStyle">
      <div class="header" [style]="headerStyle">
        <img alt="Logo" [src]="logoImg" width="220" *ngIf="logoImg">
      </div>
      <div class="uk-card uk uk-card-body">
        <div class="uk-grid-collapse uk-flex-center uk-margin-auto uk-border-rounded uk-overflow-hidden">
          <div class="uk-card">
            <div class="uk-card-header uk-padding-small uk-marging uk-margin-small-bottom">
              <div class="uk-grid-small uk-flex-middle" uk-grid>
                <div class="uk-width-auto">
                    <img [src]="imgSrc" width="30" height="41" uk-svg>
                </div>
                <h3 class="uk-width-expand uk-text-center uk-padding-remove uk-margin-small-left" [style]="titleStyle">
                  {{model['title_'+model.language]}}</h3>

              </div>
            </div>
            <div class="uk-card-body uk-background-muted uk-margin-small-bottom">
              <div class="uk-height-medium uk-overflow-auto uk-text-left terms">
                <div [innerHTML]="model['content_'+model.language] | sanitizeHtml" [style]="contentStyle"></div>
              </div>
            </div>
            <form autocomplete="off"
              class="uk-form-stacked uk-card-footer uk-padding uk-padding-remove-top uk-padding-remove-horizontal">
              <div class="uk-text-center uk-margin-medium-top">
                <button type="button" class="uk-button uk-button-primary uk-button-medium uk-width-1-2" (click)="onClose(true)"
                  [style]="buttonStyle">{{model.language=='en'?'Agree':'ตกลง'}}</button>
              </div>
              <!-- <div class="uk-padding-small" style="padding-top: 22px;">
                <small class="uk-text-middle">ท่านสามารถดูข้อมูลประกันภัยและรับบริการหลังการขายด้านประกันภัยผ่าน Line Mazda MPI</small>
              </div> -->
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="uk-position-bottom-center uk-padding-small">
    <small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
  </div>

</section>